import { Controller } from "@hotwired/stimulus"

// Dispara un click programatico sobre el elemento al conectarse.
// Util para disparar la navegacion de un turbo-frame al cargar la pagina
// (ej: auto-abrir modal de configuracion tras callback OAuth).
//
// Opcionalmente limpia query params del URL antes del click (via
// history.replaceState). Util para flags transitorios como ?configure=1
// que ya cumplieron su rol y no deben sobrevivir a un refresh.
//
// Uso:
//   <%= link_to ..., data: {
//         controller: "manage--auto-click",
//         manage__auto_click_delay_value: 150,
//         manage__auto_click_clean_params_value: ["configure", "user_integration_id"]
//       } %>
export default class extends Controller {
  static values = {
    delay:       { type: Number, default: 0 },
    cleanParams: { type: Array,  default: [] }
  }

  connect() {
    this.cleanQueryParams()
    const run = () => this.element.click()
    if (this.delayValue > 0) {
      setTimeout(run, this.delayValue)
    } else {
      run()
    }
  }

  cleanQueryParams() {
    if (this.cleanParamsValue.length === 0) return
    const url = new URL(window.location.href)
    let touched = false
    this.cleanParamsValue.forEach((param) => {
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param)
        touched = true
      }
    })
    if (touched) history.replaceState({}, "", url.toString())
  }
}
